
import { useMemo } from 'react';
import { Task, TaskDay } from '@/types/tasks';

export const useTaskBoardState = (
  initialTasks?: Task[],
  isTransitioning: boolean = false
) => {
  // Compute days directly from initialTasks without storing in state
  const days = useMemo((): TaskDay[] => {
    const tasksToUse = initialTasks || [];
    return [{ id: 'all-tasks', title: 'Tasks', tasks: tasksToUse }];
  }, [initialTasks]);

  // These are kept for compatibility but simplified
  const setDays = () => {
    // No-op since days are computed
  };
  
  const setLocalTasks = () => {
    // No-op since we don't store local tasks anymore
  };
  
  const setShouldUseLocalTasks = () => {
    // No-op since we always use initialTasks
  };

  return {
    days,
    setDays,
    localTasks: initialTasks || [],
    setLocalTasks,
    shouldUseLocalTasks: false,
    setShouldUseLocalTasks,
    isLoading: false // Remove loading logic since it's handled upstream
  };
};
